import { useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux'
import { mapUserToLocations } from "../utils/mapper";
import { set } from "../store/locations/locationsSlice";


const USER_LOCAL_STORAGE_KEY = "user";

export const useUserBranchLocations = () => {
    const locations = useSelector(state => state.rootReducer.locations.value)
    const dispatch = useDispatch();
    // fetch user branch locations from local storage
    const fetchUserBranchLocations = () => {
        // fetch user from local storage
        const user = JSON.parse(localStorage.getItem(USER_LOCAL_STORAGE_KEY));
        return mapUserToLocations(user);
    }
    // Find branch location by id
    const findBranchLocationById = (locationId) => {
        return locations.find((location) => location.clinicLocationId === locationId);
    }

    // Set branch locations
    const setBranchLocations = (locations) => {
        dispatch(set(locations));
    }

    // Initial fetch of user's branch locations
    useEffect(() => {
        const persistedLocations = fetchUserBranchLocations();
        setBranchLocations(persistedLocations);
    }, []);

    return {
        locations,
        setBranchLocations,
        fetchUserBranchLocations,
        findBranchLocationById
    }
}